import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../../../config/axios';
import axios from 'axios';
import { AddDefaultImprestType, UpdateDefaultImprestType, DeleteDefaultImprestType } from './ImprestFormatComponents';
import { Office, SearchSmall } from '../../AllSvg';
import usePermission from '../../../config/permissions';

const ImprestFormatTable = () => {

    const [buffer, setBuffering] = useState(false);
    const [imprestTypeFormat, setImprestTypeFormat] = useState([]);
    // const [toggleCompany, setToggleCompany] = useState('null');
    const [toggleCompany, setToggleCompany] = useState('a2b6154c-5c4a-4bcb-a4ec-b151c5c652b5');
    const { SUB_COMPANIES } = usePermission();

    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const getImprestTypeFormat = async () => {
        try {
            setBuffering(true);
            const res = await axios.get(`${BASE_URL}/siteproject/impresttypebysubcompany/${toggleCompany}/`);
            setImprestTypeFormat(res.data);
        } catch (error) {
            console.error(error);
        } finally {
            setBuffering(false);
        }
    }

    useEffect(() => {
        getImprestTypeFormat();
    }, [toggleCompany]);

    return (
        <div>
            <div className="table-css-white-background">
                <div className="form-flex-wrap" style={{ overflow: "scroll" }}>
                    <div className="table-heading-flex justify-between" style={{ width: "100%" }}>
                        <div className="repo-heading font-weight500    font-size-heading pl15 mb0">
                            Imprest Default Types
                        </div>
                        <div className="field-cont">
                            <div title="Select SubCompany" className="table-searchh dropdown-container field-cont-div">
                                <Office />
                                <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany}
                                    className="dropdown font-size-subheading  "
                                    style={{ cursor: "pointer" }}
                                >
                                    <option value="null">Select SubCompany</option>
                                    {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                </select>
                            </div>
                            <div title='Search' className="table-searchh">
                                <div>
                                    <SearchSmall />
                                    <input
                                        placeholder="Search"
                                        className="navbar-inputt font-weight400  font-size-text"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                            </div>
                            <AddDefaultImprestType getImprestTypeFormat={getImprestTypeFormat} />
                        </div>
                    </div>
                    <div className='table-box  scroll-container-table' style={{ width: "100%" }}>
                        <table className="table-css" >
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text text-left-sr">S.no.</th>
                                    <th className="table-heading-text text-center">Sub Company</th>
                                    <th className="table-heading-text text-center">Imprest Type Name</th>
                                    <th className="table-heading-text text-right" style={{ justifyContent: 'right' }}>Action</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner-bgdatil"></div>//buffering logic
                            ) : (
                                <tbody>
                                    {imprestTypeFormat
                                        ?.filter((e) =>
                                            e.other_name.toLowerCase().includes(searchQuery.toLowerCase())
                                        )
                                        .sort((a, b) =>
                                            a.other_name?.localeCompare(b.other_name, "en", {
                                                ignorePunctuation: true,
                                            })
                                        )
                                        .sort((a, b) =>
                                            a.subCompany_title?.localeCompare(b.subCompany_title, "en", {
                                                ignorePunctuation: true,
                                            })
                                        )
                                        .map((i, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="custom-table-head-td ">
                                                    <td className="table-body ">{index + 1}</td>
                                                    <td className="table-body text-center">{i.subCompany_title}</td>
                                                    <td className="table-body text-center ">{i.other_name}</td>
                                                    <td className="table-body text-right" style={{ justifyContent: 'right' }}>
                                                        <UpdateDefaultImprestType
                                                            i={i}
                                                            getImprestTypeFormat={getImprestTypeFormat}
                                                        />
                                                        <DeleteDefaultImprestType
                                                            i={i}
                                                            getImprestTypeFormat={getImprestTypeFormat} />
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ImprestFormatTable